// MenteesPage.js
import React, { useEffect, useState } from 'react'
import axios from 'axios'

function MenteesPage() {
  const [mentees, setMentees] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    const loadMentees = async () => {
      try {
        const res = await axios.get('/mentees', { withCredentials: true })
        setMentees(res.data)
      } catch (err) {
        setError(err.response?.data || 'Fehler')
      }
    }
    loadMentees()
  }, [])  

  if (error) return <p style={{ color: 'red' }}>{error}</p>

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Mentees</h2>
      <ul>
        {mentees.map(m => (
          <li key={m.id}>
            {m.email} | goals: {m.goals}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MenteesPage
